import { render, staticRenderFns } from "./StaffType.vue?vue&type=template&id=250f6cd0"
import script from "./StaffType.vue?vue&type=script&lang=js"
export * from "./StaffType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports